module.exports = __webpack_public_path__ + "static/media/HighFive_LHM_2.0968b419.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HighFive_LHM_2.jpg
// module id = 479
// module chunks = 0